export default __webpack_public_path__ + "static/media/arrowup.c2352c97.svg";